"use strict";

var _classCallCheck = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var promise_memoize_1 = __importDefault(require("promise-memoize"));

var StreamMessageValidator_1 = __importDefault(require("./StreamMessageValidator"));

var SigningUtil_1 = __importDefault(require("./SigningUtil"));
/**
 * A thin wrapper around StreamMessageValidator that adds caching for the following
 * expensive functions passed to the constructor:
 * - getStream
 * - isPublisher
 * - isSubscriber
 *
 * Caching the verify function does not make sense, because the input is always unique.
 */


var CachingStreamMessageValidator = /*#__PURE__*/function (_StreamMessageValidat) {
  _inherits(CachingStreamMessageValidator, _StreamMessageValidat);

  var _super = _createSuper(CachingStreamMessageValidator);

  /**
   * @param getStream async function(streamId): returns the stream metadata object for streamId
   * @param isPublisher async function(address, streamId): returns true if address is a permitted publisher on streamId
   * @param isSubscriber async function(address, streamId): returns true if address is a permitted subscriber on streamId
   * @param verify async function(address, payload, signature): returns true if the address and payload match the signature
   * @param cacheTimeoutMillis Number: Cache timeout in milliseconds. Default 15 minutes.
   * @param cacheErrorsTimeoutMillis Number: Cache timeout for error responses. Default 1 minute.
   */
  function CachingStreamMessageValidator(_ref) {
    var getStream = _ref.getStream,
        isPublisher = _ref.isPublisher,
        isSubscriber = _ref.isSubscriber,
        _ref$verify = _ref.verify,
        verify = _ref$verify === void 0 ? SigningUtil_1.default.verify : _ref$verify,
        _ref$cacheTimeoutMill = _ref.cacheTimeoutMillis,
        cacheTimeoutMillis = _ref$cacheTimeoutMill === void 0 ? 15 * 60 * 1000 : _ref$cacheTimeoutMill,
        _ref$cacheErrorsTimeo = _ref.cacheErrorsTimeoutMillis,
        cacheErrorsTimeoutMillis = _ref$cacheErrorsTimeo === void 0 ? 60 * 1000 : _ref$cacheErrorsTimeo;

    _classCallCheck(this, CachingStreamMessageValidator);

    StreamMessageValidator_1.default.checkInjectedFunctions(getStream, isPublisher, isSubscriber, verify);
    var memoizeOpts = {
      maxAge: cacheTimeoutMillis,
      maxErrorAge: cacheErrorsTimeoutMillis
    };
    return _super.call(this, {
      getStream: promise_memoize_1.default(getStream, memoizeOpts),
      isPublisher: promise_memoize_1.default(isPublisher, memoizeOpts),
      isSubscriber: promise_memoize_1.default(isSubscriber, memoizeOpts),
      verify: verify
    });
  }

  return CachingStreamMessageValidator;
}(StreamMessageValidator_1.default);

exports.default = CachingStreamMessageValidator;